import React, { CSSProperties } from 'react';

import './sidebarLoader.scss';

interface Props {
    style?: CSSProperties;
}

const SidebarLoader: React.SFC<Props> = ({ style }) => (
    <div className="__app-SidebarLoader-container" style={style}>
        <div styleName="circle" />
        <div styleName="circle" />
    </div>
);

export default SidebarLoader;
